export const MAX_CHARACTER_COUNT = 300;
